import PropTypes from 'prop-types';
import React from 'react';

const CalciteInputNumber = ({
  id,
  testId,
  className,
  alignment,
  autocomplete,
  autofocus,
  clearable,
  disabled,
  enterKeyHint,
  groupSeparator,
  hidden,
  icon,
  iconFlipRtl,
  inputMode,
  label,
  loading,
  max,
  maxLength,
  messageOverrides,
  min,
  minLength,
  name,
  numberButtonType,
  numberingSystem,
  placeholder,
  prefixText,
  readOnly,
  required,
  scale,
  status,
  step,
  suffixText,
  value,
  onChange,
  onInput,
}) => {
  const calciteInputRef = React.useRef(null);
  React.useEffect(() => {
    const element = calciteInputRef.current;
    if (onChange && element) {
      element.addEventListener('calciteInputNumberChange', onChange);
    }
    if (onInput && element) {
      element.addEventListener('calciteInputNumberInput', onInput);
    }
    return () => {
      if (onChange && element) {
        element.removeEventListener('calciteInputNumberChange', onChange);
      }
      if (onInput && element) {
        element.removeEventListener('calciteInputNumberInput', onInput);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <calcite-input-number
      data-testid={testId}
      id={id ?? undefined}
      class={className ?? undefined}
      alignment={alignment ?? undefined}
      autocomplete={autocomplete ?? undefined}
      autofocus={autofocus ?? undefined}
      clearable={clearable ?? undefined}
      disabled={disabled ?? undefined}
      enter-key-hint={enterKeyHint ?? undefined}
      group-separator={groupSeparator ?? undefined}
      hidden={hidden ?? undefined}
      icon={icon ?? undefined}
      icon-flip-rtl={iconFlipRtl ?? undefined}
      input-mode={inputMode ?? undefined}
      label={label ?? undefined}
      loading={loading ?? undefined}
      max={max ?? undefined}
      max-length={maxLength ?? undefined}
      message-overrides={messageOverrides ?? undefined}
      min={min ?? undefined}
      min-length={minLength ?? undefined}
      name={name ?? undefined}
      number-button-type={numberButtonType ?? undefined}
      numbering-system={numberingSystem ?? undefined}
      placeholder={placeholder ?? undefined}
      prefix-text={prefixText ?? undefined}
      read-only={readOnly ?? undefined}
      required={required ?? undefined}
      scale={scale ?? undefined}
      status={status ?? undefined}
      step={step ?? undefined}
      suffix-text={suffixText ?? undefined}
      value={value ?? undefined}
      ref={calciteInputRef}
      onChange={onChange || undefined}
      onInput={onInput || undefined}
    ></calcite-input-number>
  );
};

CalciteInputNumber.propTypes = {
  id: PropTypes.string,
  testId: PropTypes.string,
  className: PropTypes.string,
  alignment: PropTypes.oneOf(['start', 'end']),
  autocomplete: PropTypes.string,
  autofocus: PropTypes.bool,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  enterKeyHint: PropTypes.string,
  groupSeparator: PropTypes.bool,
  hidden: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  iconFlipRtl: PropTypes.bool,
  inputMode: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  messageOverrides: PropTypes.object,
  min: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  numberButtonType: PropTypes.oneOf(['none', 'horizontal', 'vertical']),
  numberingSystem: PropTypes.string,
  placeholder: PropTypes.string,
  prefixText: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  scale: PropTypes.oneOf(['s', 'm', 'l']),
  status: PropTypes.oneOf(['idle', 'invalid', 'valid']),
  step: PropTypes.oneOfType([PropTypes.oneOf(['any']), PropTypes.number]),
  suffixText: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onInput: PropTypes.func,
};

export default CalciteInputNumber;
